import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { OffPlatformLifeTimeAllowance } from '../../Models/Domains/Account/OffPlatformLifeTimeAllowance';

declare var IS_RUNNING_IN_APP_POOL;

export class UpdateLifetimeAllowanceClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public get(hierarchyId: string): Promise<OffPlatformLifeTimeAllowance, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Account/UpdateLifetimeAllowance/Get';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { hierarchyId: hierarchyId }

    return AjaxWrapper.get<OffPlatformLifeTimeAllowance, any>(url, data);
  }
  public put(hierarchyId: string, instruction: OffPlatformLifeTimeAllowance): Promise<OffPlatformLifeTimeAllowance, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Account/UpdateLifetimeAllowance/Put';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { hierarchyId: hierarchyId, instruction: instruction }

    return AjaxWrapper.put<OffPlatformLifeTimeAllowance, any>(url, data);
  }
}

